export default "__VITE_ASSET__CWtvA2oX__"